/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { SimpleInvoiceData } from '../models/SimpleInvoiceData'
import type { StripeInvoiceStatus } from '../models/StripeInvoiceStatus'

import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class OrganizationsStripeSubscriptionsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * Return a list of invoices.
     * @returns any OK
     * @throws ApiError
     */
    public getStripeInvoices({
        organizationId,
        limit = 100,
        startingAfter,
        status
    }: {
        /**
         * The ID of the organization to retrieve invoices for
         */
        organizationId: number
        /**
         * The number of invoices to return
         */
        limit?: number
        /**
         * Get invoices after this date. Can be anything that can be parsed by Carbon
         */
        startingAfter?: string
        /**
         * Get invoices with specific statuses
         */
        status?: StripeInvoiceStatus
    }): CancelablePromise<{
        data: Array<SimpleInvoiceData>
        /**
         * There are more invoices to fetch
         */
        has_more: boolean
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organizations/{organizationId}/invoices',
            path: {
                organizationId: organizationId
            },
            query: {
                limit: limit,
                starting_after: startingAfter,
                status: status
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Return a customer's invoice, either with an ID or the upcoming invoice.
     * @returns any OK
     * @throws ApiError
     */
    public getStripeInvoice({
        organizationId,
        invoiceId
    }: {
        /**
         * The ID of the organization to retrieve invoices for
         */
        organizationId: number
        /**
         * The ID of the invoice to retrieve. Use "upcoming" to retrieve the upcoming invoice for your organization.
         */
        invoiceId: string
    }): CancelablePromise<{
        data: SimpleInvoiceData
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organizations/{organizationId}/invoices/{invoiceId}',
            path: {
                organizationId: organizationId,
                invoiceId: invoiceId
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Get texts sent in the current invoice period.
     * @returns any OK
     * @throws ApiError
     */
    public getTextsSent({
        organizationId,
        from,
        to,
        byMonth
    }: {
        /**
         * The ID of the organization to retrieve invoices for
         */
        organizationId: number
        /**
         * First day of the desired billing period. Defaults to the current month. Format is anything parsable by Carbon.
         */
        from?: string
        /**
         * Last day of the desired billing period. If missing, a month is added to the from date.
         */
        to?: string
        /**
         * Get the number of texts sent in the month of the from date. Defaults to false.
         */
        byMonth?: boolean
    }): CancelablePromise<{
        /**
         * The number of texts sent this month
         */
        data?: number
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/organizations/{organizationId}/texts',
            path: {
                organizationId: organizationId
            },
            query: {
                from: from,
                to: to,
                by_month: byMonth
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }
}
